export default __webpack_public_path__ + "static/media/comm 9.6c51e5da.png";